/**
 * 全局loading组件
 */
var LOADING_DOM = {
    /**
     * 显示loading
     */
    showLoading() {
        var loading = document.getElementById('loading');
        if(loading) {
            loading.style.display = 'block';
        }
    },
    /**
     * 隐藏loading
     */
    hideLoading() {
        var loading = document.getElementById('loading');
        if(loading) {
            loading.style.display = 'none';
        }
    }
}

export {
    LOADING_DOM
}